import { apiClient } from "helpers/api_helper";

export const getAllSalesEntryListData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/SalesInventory/GetSalesInventory`,data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSalesEntryDetailsById = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/SalesInventory/GetSalesOrderItemBySalesOrderId?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};